/* ============================================================
   PROOF — global theme JS (loaded on every page with `defer`).
   Provides: money formatting, a global Alpine cart store, and a
   tiny event helper. Component-specific Alpine.data() registrations
   live in {% javascript %} tags alongside their markup.
   ============================================================ */
(function () {
  window.PROOF = window.PROOF || {};

  /* ---- Money formatting (Shopify money_format aware) ---- */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    const fmt = format || window.PROOF.moneyFormat || '${{amount}}';
    const placeholder = /\{\{\s*(\w+)\s*\}\}/;

    function withDelimiters(number, precision, thousands, decimal) {
      precision = precision == null ? 2 : precision;
      thousands = thousands || ',';
      decimal = decimal || '.';
      if (isNaN(number) || number == null) return '0';
      number = (number / 100.0).toFixed(precision);
      const parts = number.split('.');
      const dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      const cents = parts[1] ? decimal + parts[1] : '';
      return dollars + cents;
    }

    let value = '';
    const match = fmt.match(placeholder);
    const token = match ? match[1] : 'amount';
    switch (token) {
      case 'amount': value = withDelimiters(cents, 2); break;
      case 'amount_no_decimals': value = withDelimiters(cents, 0); break;
      case 'amount_with_comma_separator': value = withDelimiters(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = withDelimiters(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = withDelimiters(cents, 2, "'", '.'); break;
      default: value = withDelimiters(cents, 2);
    }
    return fmt.replace(placeholder, value);
  }
  window.PROOF.formatMoney = formatMoney;

  /* ---- Global Alpine cart store ---- */
  document.addEventListener('alpine:init', () => {
    Alpine.store('cart', {
      open: false,
      loading: false,
      item_count: 0,
      items: [],
      total_price: 0,
      total_discount: 0,
      discount_codes: [],
      recommendations: [],
      discountCode: '',
      discountError: '',
      discountLoading: false,
      discountOpen: false,
      freeShippingThreshold: (window.PROOF.freeShippingThreshold || 0),

      get remainingForFreeShipping() {
        return Math.max(0, this.freeShippingThreshold - this.total_price);
      },
      get freeShippingPct() {
        if (!this.freeShippingThreshold) return 0;
        return Math.min(100, (this.total_price / this.freeShippingThreshold) * 100);
      },
      get freeShippingUnlocked() {
        return this.freeShippingThreshold > 0 && this.total_price >= this.freeShippingThreshold;
      },
      get hasDiscount() { return this.total_discount > 0 && this.discount_codes.length > 0; },

      init() {
        // Seed from the Liquid-rendered snapshot to avoid an extra fetch on load.
        if (window.PROOF.cart) this.setCart(window.PROOF.cart);
        // Auto-open the drawer when redirected here from /cart.
        try {
          if (sessionStorage.getItem('proof:open-cart')) {
            sessionStorage.removeItem('proof:open-cart');
            const self = this;
            setTimeout(function () { self.openDrawer(); }, 60);
          }
        } catch (e) {}
      },

      setCart(cart) {
        this.item_count = cart.item_count;
        this.items = cart.items || [];
        this.total_price = cart.total_price;
        this.total_discount = cart.total_discount || 0;
        this.discount_codes = (cart.discount_codes || []).filter(function (d) { return d.applicable; });
      },

      money(cents) { return formatMoney(cents); },

      routes() { return (window.PROOF && window.PROOF.routes) || {}; },

      async refresh() {
        const res = await fetch(`${this.routes().cart || '/cart'}.js`, { headers: { 'Accept': 'application/json' } });
        this.setCart(await res.json());
      },

      openDrawer() { this.open = true; document.body.classList.add('proof-no-scroll'); this.loadRecommendations(); },
      closeDrawer() { this.open = false; document.body.classList.remove('proof-no-scroll'); },

      async loadRecommendations() {
        if (!window.PROOF.cartUpsells || !this.items.length) { this.recommendations = []; return; }
        const pid = this.items[0].product_id;
        const inCart = {};
        this.items.forEach(function (i) { inCart[i.product_id] = true; });
        try {
          const url = `/recommendations/products.json?product_id=${pid}&intent=related&limit=10`;
          const res = await fetch(url, { headers: { 'Accept': 'application/json' } });
          const data = await res.json();
          this.recommendations = (data.products || [])
            .filter(function (p) { return !inCart[p.id] && p.available; })
            .slice(0, 3)
            .map(function (p) {
              const single = p.variants && p.variants.length === 1;
              let img = p.featured_image || (p.images && p.images[0]) || null;
              if (img && img.indexOf('//') === 0) img = 'https:' + img;
              return {
                id: p.id, title: p.title, url: p.url, price: p.price, image: img,
                addable: !!(single && p.variants[0].available),
                variantId: single ? p.variants[0].id : null,
                variants: single ? [] : (p.variants || []).map(function (v) {
                  return { id: v.id, title: v.title, available: v.available, price: v.price };
                }),
              };
            });
        } catch (e) { this.recommendations = []; }
      },

      async applyDiscount() {
        const code = (this.discountCode || '').trim();
        if (!code) return;
        this.discountLoading = true;
        this.discountError = '';
        try {
          await fetch(`/discount/${encodeURIComponent(code)}`, { headers: { 'Accept': 'text/html' } });
          await this.refresh();
          const applied = this.discount_codes.find(function (d) { return d.code.toLowerCase() === code.toLowerCase(); });
          if (applied) { this.discountCode = ''; this.discountOpen = false; }
          else { this.discountError = 'Ese código no aplica a tu carrito.'; }
        } catch (e) {
          this.discountError = 'No se pudo aplicar el código. Inténtalo de nuevo.';
        } finally {
          this.discountLoading = false;
        }
      },

      async add(body) {
        this.loading = true;
        try {
          const res = await fetch(`${this.routes().cart_add || '/cart/add'}.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify(body),
          });
          if (!res.ok) {
            const err = await res.json();
            throw new Error(err.description || 'No se pudo agregar. Inténtalo de nuevo — guardamos tu carrito.');
          }
          await this.refresh();
          this.openDrawer();
          this.$dispatch && this.$dispatch('cart:updated');
          window.dispatchEvent(new CustomEvent('cart:updated'));
          return true;
        } finally {
          this.loading = false;
        }
      },

      async changeQty(key, quantity) {
        this.loading = true;
        try {
          const res = await fetch(`${this.routes().cart_change || '/cart/change'}.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ id: key, quantity }),
          });
          this.setCart(await res.json());
          window.dispatchEvent(new CustomEvent('cart:updated'));
        } finally {
          this.loading = false;
        }
      },

      remove(key) { return this.changeQty(key, 0); },
    });
  });
})();
